import React from "react";
import PoweredByComponent from "../../webview-components/powered-by";

const PaymentSessionTimedout = () => {
  return (
    <>
        <div className="payment-form-wrapper">
          <div className="form-wrapper text-start mt-5">
            <div className="text-center mt-5 pt-5 mb-2 pb-0">
              <h4 className="mb-2">Your payment session has timed out</h4>
              <p className="note">Looks like your session expired before the payment could be completed. Don't worry — if any amount was deducted, it will be fully refunded.</p>
            </div>
          </div>
        </div>

        <PoweredByComponent></PoweredByComponent>
    </>
  );
};

export default PaymentSessionTimedout;
